import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Fab from "@mui/material/Fab";
import wtechinLogo from "../../images/wtechin.png";
import React from "react";
import Backdrop from "@mui/material/Backdrop";

const Loading = ({ isLoading }) => {
  return (
    <Backdrop
      open={isLoading}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        bgcolor: "rgba(255,255,255,0.7)", // arka planı şeffaf beyaz yap
      }}
    >
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "transparent", // Box arka planı da şeffaf
        }}
      >
        <Box sx={{ m: 1, position: "relative" }}>
          <Fab
            aria-label="logo"
            sx={{
              width: 100,
              height: 100,
              bgcolor: "#fff",
              boxShadow: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={wtechinLogo}
              alt="Logo"
              style={{
                width: 60,
                height: 60,
                objectFit: "contain",
                borderRadius: "50%",
                background: "#fff",
              }}
            />
          </Fab>
          {isLoading && (
            <CircularProgress
              size={110}
              sx={{
                position: "absolute",
                top: -5,
                left: -5,
                zIndex: 1,
              }}
            />
          )}
        </Box>
      </Box>
    </Backdrop>
  );
};

export default Loading;
